import { render, staticRenderFns } from "./TextCopy.vue?vue&type=template&id=9b44f532&scoped=true&"
import script from "./TextCopy.vue?vue&type=script&lang=js&"
export * from "./TextCopy.vue?vue&type=script&lang=js&"
import style0 from "./TextCopy.vue?vue&type=style&index=0&id=9b44f532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b44f532",
  null
  
)

export default component.exports